export const maxLengthBik = 9;

export const maxLengthCheck = 20;
export const maxLengthCorrespondentCheck = 20;

export const maxLengthPassportSeries = 4;
export const maxLengthPassportNumber = 6;
export const maxLengthPassportDivisionCode = 7;
export const maxLengthPassportPostIndex = 6;
export const maxLengthPassporDefaultLength = 6;

export const maxLengthInn = 12;
export const maxLengthSnils = 11;
export const maxLengthPhoneNumber = 12;
